/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MockWETH, MockWETHInterface } from "../MockWETH";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "Withdrawal",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "guy",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dst",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "src",
        type: "address",
      },
      {
        internalType: "address",
        name: "dst",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "wad",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class MockWETH__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MockWETH> {
    return super.deploy(overrides || {}) as Promise<MockWETH>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MockWETH {
    return super.attach(address) as MockWETH;
  }
  connect(signer: Signer): MockWETH__factory {
    return super.connect(signer) as MockWETH__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockWETHInterface {
    return new utils.Interface(_abi) as MockWETHInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockWETH {
    return new Contract(address, _abi, signerOrProvider) as MockWETH;
  }
}
